import { useQuery } from "@tanstack/react-query";
import { api, endpoints } from "api/api";

export interface ViolatedBundle {
  userId: number;
  userEmail: string;
  userFullName: string;
  discountId: number;
  discountCode: string;
  discountDescription: string;
  violationReason: string;
  lastChangedAt: string;
}

const fetchViolatedBundles = async (): Promise<ViolatedBundle[]> => {
  const { data } = await api.get<ViolatedBundle[]>(
    endpoints.DISCOUNTS.VIOLATED_BUNDLES(),
  );
  return data;
};

export const useViolatedBundles = () =>
  useQuery({
    queryKey: ["violated-bundles"],
    queryFn: fetchViolatedBundles,
  });
